import { Button } from '@mui/material';
import { IconDeviceFloppy } from '@tabler/icons-react';
import React from 'react';

export default function BtnSave({ style, disabled, onClick }) {
  const customStyle = { cursor: 'pointer', ...style };

  return (
    <Button variant="contained" onClick={onClick} style={customStyle} disabled={disabled}>
      <IconDeviceFloppy height={20} />
    </Button>
  );
}
